import { useFirmContext } from '../../../providers/FirmProvider';
import RemoveUsersConfirmDialog from '../../users/RemoveUsersConfirmDialog';
import { useState } from 'react';
import { User } from '../../../types/user';
import SettingsContainer from '../../../components/settings-container/SettingsContainer';
import SectionLabel from '../../../components/section-label/SectionLabel';
import { ButtonV2 } from '@cimplico/components';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

type RemoveUserProps = {
    user: User;
};

function RemoveUsers({ user }: RemoveUserProps): JSX.Element {
    const firm = useFirmContext();
    const [removeUser, setRemoveUser] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <RemoveUsersConfirmDialog
                userIds={[user.id]}
                isOpen={removeUser}
                onClose={(): void => setRemoveUser(false)}
                onRemove={(): void => {
                    setRemoveUser(false);
                    navigate(`/${firm.shortId}/settings?tab=users`);
                }}
            />
            <SettingsContainer>
                <SectionLabel title="Remove user" description={`Remove this user from ${firm.name}`} />
                <div className="flex items-center">
                    <ButtonV2
                        label="Remove from firm"
                        type="danger"
                        size="sm"
                        leftIcon={<ExclamationTriangleIcon />}
                        onClick={(): void => setRemoveUser(true)}
                    />
                </div>
            </SettingsContainer>
        </>
    );
}

export default RemoveUsers;
